export default {
  state: {
    docVersions: [],
    loading: false,
  },
  getters: {
    docVersions: state => state.docVersions,
    loading: state => state.loading,
  },
  mutations: {
    setDocVersion(state, docVersion) {
      state.docVersions = docVersion;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
  },
  actions: {
    async fetchAll({ commit, dispatch, state }, queryString) {
      commit('setLoading', true);
      try {
        const docVersion = await axios.get('api/doc-versions' + (queryString || ''));
        commit('setDocVersion', docVersion);
      } catch (e) {
      }
      commit('setLoading', false);
    },
    async fetch({ commit }, id) {
      return await axios.get(`api/doc-versions/${id}`);
    },
    async create({ commit }, { data, config }) {
      await axios.post('api/doc-versions', data, config);
    },
    async update({ commit }, { data, config }) {
      await axios.put('api/doc-versions', data, config);
    },
    async delete({ commit }, id) {
      await axios.delete(`api/doc-versions/${id}`);
    },
  },
};
